export const environment = {
  production: true,
  baseUrl: 'https://pay.onf.ru/unsubscription',

};
